import { CriteriaQuery, Criteria } from '@fpx/core';
import { Observable } from 'rxjs';

export class HttpRequest {
  private _headerParameters?: HttpParameter[] = [];
  private _queryParameters?: HttpParameter[] = [];
  private _pathParameters?: HttpParameter[] = [];
  private _body?: any = null;
  private _criteriaQuery?: Criteria;
  private _serverContext?: string = '';
  private _setContextPath?: string = '';
  
  private _resource: string = '';
  private _method!: 'POST' | 'GET' | 'PUT' | 'DELETE';
  private _baseUrl : string = '';
  private _authTokenRequired : boolean = true;

  public addHeaderParamter(key: string, value: unknown): void {
    this._headerParameters?.push({ key: key, value: value });
  }
  public addQueryParameter(key: string, value: unknown): void {
    this._queryParameters?.push({ key: key, value: value });
  }
  public addPathParameter(key: string, value: unknown): void {
    this._pathParameters?.push({ key: key, value: value });
  }
  public setCriteriaQuery(criteriaQuery: CriteriaQuery): void {
    this._criteriaQuery = criteriaQuery.criteriaQuery();
  }
  public setBody(payload: unknown): void {
    this._body = payload;
  }
  public setResource(resourceUrl: string): void {
    this._resource = resourceUrl;
  }
  public setMethod(method: 'POST' | 'GET' | 'PUT' | 'DELETE'): void {
    this._method = method;
  }
  public setServerContext(serverContext: string): void {
    this._serverContext = serverContext;
  }
  public setContextPath(setContextPath: string): void {
    this._setContextPath = setContextPath;
  }
  
  public setBaseUrl(url:string):void{
    this._baseUrl = url;
  }

  public setAuthTokenRequired(isTokenRequired:boolean) {
    this._authTokenRequired = isTokenRequired;
  }

  get httpPayload(): HttpPayload {
    return {
      method: this._method,
      resource: this._resource,
      body: this._body,
      filterCriteria: this._criteriaQuery,
      pathParams: this._pathParameters,
      queryParams: this._queryParameters,
      headerParams: this._headerParameters,
      serverContext: this._serverContext,
      baseURl : this._baseUrl,
      isAuthTokenRequired : this._authTokenRequired
    };
  }


}

export interface HttpParameter {
  key: string;
  value: any;
}
export interface HttpPayload {
  serverContext?: string;
  resource: string;
  method: 'POST' | 'GET' | 'PUT' | 'DELETE';
  pathParams?: HttpParameter[];
  queryParams?: HttpParameter[];
  headerParams?: HttpParameter[];
  body?: any;
  filterCriteria?: Criteria;
  baseURl : string,
  isAuthTokenRequired? : boolean
}

export declare interface CreateFn<T> {
  (): Observable<T>;
}

export declare interface ModifyFn<T> {
  (): Observable<T>;
}

export declare interface FindAllFn<T> {
  (): Observable<T>;
}

export declare interface FindByKeyFn<T> {
  (): Observable<T>;
}

export declare interface LookUpFn<T> {
  (): Observable<any>;
}

export declare interface GridTransformFn<T> {
  (payload:T) : any
}

export declare interface LoadForm<T> {
  (): Observable<T>;
}

export declare interface PatchFn<T> {
  (): Observable<T>;
}


type filterColumn =
  | 'C1'
  | 'C2'
  | 'C3'
  | 'C4'
  | 'C5'
  | 'C6'
  | 'C7'
  | 'C8'
  | 'C9'
  | 'C10';

export class HttpRequestPayload {
  serverContext?: string = '';
  resource: string = '';
  method!: 'POST' | 'GET' | 'PUT' | 'DELETE';
  pathParams?: IHttpParam[];
  queryParams?: IHttpParam[];
  headerParams?: IHttpParam[];
  body?: any;
  filterCriteria?: IFilterSortCriteria;
}

export interface IHttpParam {
  key: string;
  value: string | number;
}

export interface IHttpSuccessPayload<T> {
  body: T;
  httpStatus: number;
}

export interface IHttpErrorPayload {
  error: IExceptionObj;
  status: number;
  statusText: string;
}

export interface IExceptionObj {
  errorCode: string;
  errorDescription: string;
  errorMessage: string;
}

export interface ILookupResponse {
  Data:  ILookUpData[];
  ccbillingperiod: ILookUpData[];
}
export interface ILookUpData {
  id: string;
  text: string;
  StartDate: string;
  PeriodNumber: string;
  EndDate: string;
}

export interface LookUpData {
  id : string;
  text : string;
  StartDate: string;
  PeriodNumber: string;
  EndDate: string;
}

type filterOperators = '&' | '|';

type filerCriteria =
  | `C1${filterOperators}C2`
  | `C1${filterOperators}C2${filterOperators}C3`
  | `C1${filterOperators}C2${filterOperators}C3${filterOperators}C4`
  | `C1${filterOperators}C2${filterOperators}C3${filterOperators}C4${filterOperators}C5`
  | `C1${filterOperators}C2${filterOperators}C3${filterOperators}C4${filterOperators}C5${filterOperators}C6`;

export interface IFilterSortCriteria {
  Offset: string;
  Count: number;
  FilterExpression?: filerCriteria;
  FilterCriteria: Ifilter[];
}

export interface Ifilter {
  columnName: string;
  columnType: 'Date' | 'Timestamp' | 'String' | 'Numeric';
  conditions: {
    searchType: searchType;
    searchText: string | string[];
    fromValue?: string;
    toValue?: string;
  };
}

type searchType =
  | 'Contains'
  | 'equals'
  | 'notEqual'
  | 'startsWith'
  | 'endsWith'
  | 'greaterThan'
  | 'lessThan'
  | 'greaterThanEquals'
  | 'lessThanEquals'
  | 'inRange'
  | 'isNull'
  | 'isNotNull';
